<template>
<div class="content" id="DataIndex">
	<router-view />
</div>
</template>
<script>
export default {
    name: 'DataIndex',
    //组件创建
    created() {
    },
    data() {
        return{
        }
    },
    methods:{
    }
}
</script>
<style lang="less" scoped>
</style>